<template>
  <b-modal :id="id" centered hide-footer :title="title" @hidden="hidden" @hide="hidden">
    <sweet-textarea
      :isValid="!$v.form.description.$error"
      class="mt-3"
      v-model="form.description"
      type="text"
      layout="vertical"
      :placeholder="$t('common.description')"
      :label="$t('common.description')"
      :rows="10"
    />
    <sweet-button :disabled="$v.$invalid || isUpdating" :loading="isUpdating" @click="handle" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </b-modal>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["policy", "id"],
  components: { SweetTextarea },
  validations: {
    form: {
      description: {
        required,
      },
    },
  },
  data() {
    return { form: { description: undefined, status: undefined, id: undefined } };
  },

  computed: {
    title() {
      if (this.policy?.status == "NOT_APPLICABLE") {
        return this.$t("policy.make-not-applicable");
      } else {
        return this.$t("policy.revert-not-applicable");
      }
    },
    isUpdating() {
      return this.$store.getters["organizationPolicy/isUpdating"];
    },
  },
  methods: {
    hidden() {
      this.$emit("hidden");
    },

    async handle() {
      try {
        const store = this.policy.status == "NOT_APPLICABLE" ? `organizationPolicy/delete` : `organizationPolicy/revertDeleted`;
        this.form.status = this.policy.status;
        this.form.id = this.policy._id;

        await this.$store.dispatch(store, this.form);

        this.$toast.success(this.$t("common.successful"));
        this.hidden();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
      }
    },
  },
};
</script>
